import { connect } from 'react-redux';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import * as dealInfoHelpers from 'shared/utils/deal-info-helpers';

import translations from './translations';

@connect((state, ownProps) => ({
  subscriptionPriceInfo: dealInfoHelpers.getSubscriptionPriceInfo(ownProps.dealInfo),
}))
export default class ChannelSubscriptionLabel extends React.Component {

  static propTypes = {
    subscriptionPriceInfo: React.PropTypes.object,
    dealInfo: React.PropTypes.array,
    className: React.PropTypes.string,
  };

  render() {
    const { subscriptionPriceInfo, className } = this.props;

    const values = {
      price: <FormattedNumber value={subscriptionPriceInfo.price}
                              style="currency"
                              currency={subscriptionPriceInfo.currency} />,
    };

    return (
      <FormattedMessage {...translations.subscribe}
                        className={className}
                        values={values} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/channel-actions/channel-subscription-label.js